/*
  utils/silenceConsole.js
  ----------------------------------
  Globally silences console output (log/info/debug/warn) when the app runs
  in ANY environment other than development. Import this as early as possible
  (e.g., first line of pages/_app.js) so it runs before other modules execute.
*/

if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'development') {
  ['log', 'info', 'debug', 'warn'].forEach((method) => {
    // eslint-disable-next-line no-console
    console[method] = () => {};
  });
}

// Intentionally left blank for tree-shaking friendliness 